export function saveToLocalStorage(key: string, value: any) {
  if (value === null || value === undefined) return;
  try {
    if (typeof value === 'string') {
      localStorage.setItem(key, value);
    } else {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    }
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
}

export function getFromLocalStorage(key: string) {
  const value = localStorage.getItem(key);
  if (value === null) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

export function removeFromLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export const clearLocalStorage = () => {
  localStorage.clear();
};
